import { routes as supplierConfigRoutes } from "./suppliers/routes";
import { routes as supplierTypeRoutes } from "./supplier-types/routes";
import { routes as messageRoutes } from "./messages/routes";
import { routes as shippingCompanyRoutes } from "./shipping-companies/routes";
import { routes as invoiceRoutes } from "./invoices/routes";
import { routes as grnRoutes } from "./grns/routes";
import { routes as lposRoutes } from "./lpos/routes";
import { routes as journalRoutes } from "./journals/routes";
import { routes as approvalsRoutes } from "./approvals/routes";
import { routes as reportRoutes } from "./reports/routes";
export const routes  = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}`,
        name: `${prefix}.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Supplier module Dashboard",
            },
        },
    },
    ...supplierConfigRoutes(),
    ...supplierTypeRoutes(),
    ...messageRoutes(),
    ...shippingCompanyRoutes(),
    ...invoiceRoutes(),
    ...grnRoutes(),
    ...lposRoutes(),
    ...journalRoutes(),
    ...approvalsRoutes(),
    ...reportRoutes(),
];